import { ORDER_STATES } from '@/constants/Order';
import { md5 } from '@/helper/Crypt';
import { format } from "date-fns/format";
import i18n, { exists, t } from "i18next";
import kebabCase from 'lodash/kebabCase';
import merge from 'lodash/merge';

export const _t = (text, options = {}) => {

    let defaults = {
        currency: 'EUR',
        dateFormat: 'dd.MM.yyyy',
        dateTimeFormat: 'dd.MM.yyyy HH:mm',
        timeFormat: 'HH:mm',
    };

    const _opt = merge(defaults, options);

    if (typeof text !== 'string') 
        return text;

    let orgText = text;
    let resText = text;
    let respons = '';

    const regex = /\{{(.+?)\}}/g;
    const match = text?.match(regex);

    const newOrder = [];
    
    if (typeof text === 'undefined' || text === null) {
        return;
    }

    match?.map((item, index) => {
        
        const keepValue = item.indexOf('$') ? false : true;
        let _text = item?.replace('{{', '')?.replace('}}', '');
        
        resText = resText.replace(_text, '$' + index);

        if (_text?.includes('DATE:') && _opt?.dateFormat != null) {
            const date = new Date(_text.replace('DATE:', ''));
            _text = format(date, _opt.dateFormat);
        }

        if (_text?.includes('ORDERSTATUS:')) {
            const orderStatusKey = _text.replace('ORDERSTATUS:', '');
            _text = t(ORDER_STATES[orderStatusKey]?.key);
        }

        newOrder.push({
            _id: '$' + index,
            newText : _text,
            original: item,
            keeypValue : keepValue
        })
    })

    const keyedText = 'A' + md5(kebabCase(resText));
    
    if (!exists(keyedText)) {
        
        if (__DEV__ || i18n.language != 'de') {
            //console.log('key not found:' , i18n.language , '"' + keyedText + '":', '"' + resText + '",');
            //console.log('-------');
        };

        if (newOrder.length > 0) {
            newOrder.map(item => {
                resText = resText?.replace('{{' + item._id + '}}', item.newText);
            })
        }

        return resText?.replace('[[', '')?.replace(']]', '');
    }
    
    let translatedString = t(keyedText);

    if (newOrder.length > 0) {
        newOrder.map(item => {
            translatedString = translatedString?.replace('{{' + item._id + '}}', item.newText);
        })
    }

    translatedString = translatedString?.replace('[[', '')?.replace(']]', '');
    
    return translatedString;
}